<div class="container">
  <div class="product-detail-skeleton">
    <div class="row">
      <!-- Left Column - Image Section -->
      <div class="col-12 col-md-6">
        <div class="skeleton-image-wrapper">
          <div class="skeleton-image skeleton-shimmer"></div>
          <div class="skeleton-dots">
            <span class="skeleton-dot skeleton-shimmer"></span>
            <span class="skeleton-dot skeleton-shimmer"></span>
            <span class="skeleton-dot skeleton-shimmer"></span>
          </div>
        </div>
      </div>

      <!-- Right Column - Product Info Section -->
      <div class="col-12 col-md-6">
        <div class="row">
          <!-- Title -->
          <div class="col-12">
            <div class="skeleton-title skeleton-shimmer"></div>
          </div>
        </div>

        <!-- Description -->
        <div class="row">
          <div class="col-12">
            <div class="skeleton-info-section">
              <div class="skeleton-text skeleton-shimmer"></div>
              <div class="skeleton-text skeleton-shimmer"></div>
              <div class="skeleton-text skeleton-shimmer short"></div>
              
              <div class="skeleton-list">
                <div class="skeleton-list-item skeleton-shimmer"></div>
                <div class="skeleton-list-item skeleton-shimmer"></div>
                <div class="skeleton-list-item skeleton-shimmer"></div>
              </div>
            </div>
          </div>

          <!-- Price and Button -->
          <div class="col-12">
            <div class="skeleton-actions">
              <div class="skeleton-price-section">
                <div class="skeleton-price skeleton-shimmer"></div>
                <div class="skeleton-original-price skeleton-shimmer"></div>
                <div class="skeleton-discount skeleton-shimmer"></div>
              </div>
              
              <div class="skeleton-button skeleton-shimmer"></div>
            </div>
          </div>

          <!-- Dose Progress -->
          <div class="col-12">
            <div class="skeleton-dose-section">
              <div class="skeleton-dose-options">
                <div class="skeleton-dose-badge skeleton-shimmer"></div>
                <div class="skeleton-dose-badge skeleton-shimmer"></div>
                <div class="skeleton-dose-badge skeleton-shimmer"></div>
              </div>
              <div class="skeleton-dose-text skeleton-shimmer"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

